// extracted by mini-css-extract-plugin
module.exports = {"termsBase":"styles_termsBase__A6zUT system_textBodyM__j_wxE"};